var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKpiKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.83348C13.4205 5.83348 14.1667 6.57967 14.1667 7.50014M17.5 7.50014C17.5005 9.08383 16.7506 10.5741 15.4786 11.5175C14.2066 12.461 12.5629 12.746 11.0475 12.286L9.16667 14.1668H7.5V15.8335H5.83333V17.5001H3.33333C2.8731 17.5001 2.5 17.127 2.5 16.6668V14.5118C2.50005 14.2908 2.58788 14.0789 2.74417 13.9226L7.71417 8.95264C7.14614 7.07483 7.72878 5.03834 9.20403 3.74511C10.6793 2.45187 12.7745 2.14087 14.5618 2.94986C16.3491 3.75884 17.4981 5.5383 17.5 7.50014L12.5 5.83348",
    stroke: "#059669",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiKeyIcon);
export default __webpack_public_path__ + "static/media/kpi_key_icon.b0cfaee37c8ba510bf572eb3d2adc3ac.svg";
export { ForwardRef as ReactComponent };